import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import { Option } from '../NativeSelect/NativeSelect.types'
import {
  OptionContent,
  OptionLabel,
  OptionWrapper,
  Wrapper,
} from './OptionSelector.styles'

export interface Props {
  optionList: Option[]
  textLabel?: string
  onChange?: (event) => void
}
interface State {
  currentOptionSelected: string | number
}

export class OptionSelector extends React.Component<
  Props & React.InputHTMLAttributes<any>,
  State
> {
  state = {
    currentOptionSelected: this.props.value,
  }

  onOptionClick = event => {
    this.setState({ currentOptionSelected: event.currentTarget.value })

    if (this.props.onChange) this.props.onChange(event)
  }

  render() {
    const { currentOptionSelected } = this.state
    const { optionList, textLabel } = this.props

    return (
      <>
        {textLabel && (
          <QuestionWrapper as="div" color="black" marginBottom="xxxs">
            {textLabel}
          </QuestionWrapper>
        )}
        <Wrapper>
          {optionList.map((option, index) => (
            <OptionWrapper
              key={index}
              isSelected={option.value === currentOptionSelected}
            >
              <OptionLabel isSelected={option.value === currentOptionSelected}>
                {option.text}
              </OptionLabel>
              <OptionContent
                value={option.value}
                type={
                  typeof optionList[0].value === 'number' ? 'number' : 'radio'
                }
                onClick={event => {
                  this.onOptionClick(event)
                }}
              />
            </OptionWrapper>
          ))}
        </Wrapper>
      </>
    )
  }
}
